'use strict';

const $ = window.jQuery;

export default class SmoothScroll {
    constructor() {
        $('a[href*="#"]')
            .not('[href="#"]')
            .not('[href="#0"]')
            .on('click', function (event) {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    let target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        event.preventDefault();
                        history.pushState(null, '', this.hash);
                        let offset = $('body').hasClass('single-landing-pages') ? 200 : 90;
                        $('html, body').animate({
                            scrollTop: target.offset().top - offset
                        }, 1000, function () {
                            let $target = $(target);
                            $target.focus();
                            if ($target.is(':focus')) {
                                return false;
                            } else {
                                $target.attr('tabindex', '-1');
                                $target.focus();
                            };
                        });
                    }
                }
            });
    }
}
